<div
  id="anchor-page-top"
  class="l-container js-menu-contents"
  [attr.aria-hidden]="isAriaHidden"
  [ngClass]="isChangeContainerColor ? 'l-container--light-blue02' : 'l-container'"
>
  <div class="l-contents-wrap">
    <div class="l-main">
      <ng-content select="asw-emergency-area"></ng-content>
      <div aswSemiFixedArea>
        <ng-content select="asw-header"></ng-content>
        <ng-content select=".asw-sub-header"></ng-content>
      </div>
      <div #belowHeaderContents>
        <ng-content select="asw-alert-area"></ng-content>
        <!-- [コンテンツ領域] -->
        <ng-content select="asw-contents-area"></ng-content>
        <!-- //[コンテンツ領域] -->
      </div>
    </div>
    <div #outsideContents>
      <ng-content select="asw-guidance-area"></ng-content>
      <div id="footerRecommendationArea"></div>
      <ng-content select="asw-footer"></ng-content>
      <ng-content select="asw-notification-area"></ng-content>
      <ng-content select="asw-debug-area"></ng-content>
    </div>
  </div>
</div>
